/* lua.js generated code 0.3.0 */

_G.__use_low_effect = false
// _G.__use_small_res = isUseSmallRes()
_G.__use_res_postfix = "@6x"
// _G.__use_res_scale = _G.__use_small_res && 0.625 || 1

function isUseSmallRes() {
    let use_small_res = getParameterByName("smallres")
    let openid = META.user.openid
    if (use_small_res === "1" || !openid) {
        return true
    }else if (use_small_res === "0") {
        return false
    }
    openid = tostring(openid)
    // 基数变成36以兼容所有的数字字母
    openid = parseInt(openid.substr(openid.length - 4), 36)
    return (openid % 2 === 0)
}

global.toggleUseLowEffect = function() {
    _G.__use_low_effect = false
    // 这是动画性能的选择
    if (_G.__level_effect == "LOW"){
        bool = false
        _G.__level_effect = "NORMAL"
    }else{
        bool = true
        _G.__level_effect = "LOW"
    }
    return bool
}

function decideUseLowEffect() {
    // if (isWechatGameEnv() && !mini.supportLowEffect()) {
    //     _G.__use_low_effect = false;
    // } else {
    //     let userDefault = cc.UserDefault.getInstance()
    //     let isUseLowEffect = userDefault._getValueForKey('game.enable.low.effect')
    //     // 当没有此key时应该返回null，微信小游戏中返回了空字符串
    //     if (!isUseLowEffect) {
    //         // 1. 新设备根据脚本执行效率指定初始值
    //         // 脚本执行时间大于两秒的机器使用低效

    //         // 引擎开始执行至当前时间
    //         let scriptTime = new Date().getTime() - dcUtil.getDCStartTime();
            
    //         let shouldUseLowEffect = true
    //         let lowEffectThreshold = 2000
    //         // 提高微信高清标准
    //         if (cc.sys.platform === cc.sys.WECHAT_GAME) {
    //             if (cc.sys.os === cc.sys.OS_ANDROID) {
    //                 // 枭龙835在800ms左右
    //                 lowEffectThreshold = 1200
    //             } else {
    //                 // 苹果及未知设备
    //                 // 苹果单核能力较强，未知设备从严
    //                 // iPhone6 300ms左右 iPhone7 150ms左右
    //                 lowEffectThreshold = 500
    //             }
    //         }

    //         if (scriptTime > lowEffectThreshold) {
    //             shouldUseLowEffect = true
    //         } else {
    //             shouldUseLowEffect = false
    //         }

    //         // 方式 1 中检测可能有误差
    //         // 2. 微信中能拿到一定的设备信息，比对设备型号，白名单机器强制高清
    //         if (shouldUseLowEffect && cc.sys.platform === cc.sys.WECHAT_GAME) {
    //             const goodDeviceList = [
    //                 // 'iPhone 6',
    //                 'iPhone SE',
    //                 'iPhone 7',
    //                 'iPhone 8',
    //                 'iPhone X',
    //                 'iPad Pro',
    //                 'SM-N9500',
    //                 'SM-N9508',
    //                 'SM-G9600',
    //                 'SM-G9650',
    //                 'SM-G9608',
    //                 'BKL-AL00',
    //                 'BKL-AL20',
    //                 'BKL-TL10',
    //             ].map(model => model.toLowerCase())
    //             const deviceInfo = mini.getSystemInfoSync()
    //             const deviceModel = (deviceInfo.model || '').toLowerCase()
    //             goodDeviceList.forEach(model => {
    //                 if (deviceModel.indexOf(model) > -1) {
    //                     shouldUseLowEffect = false
    //                 }
    //             })
    //         }

    //         _G.__use_low_effect = shouldUseLowEffect
    //         userDefault.setBoolForKey('game.enable.low.effect', shouldUseLowEffect)
    //     } else {
    //         _G.__use_low_effect = userDefault.getBoolForKey('game.enable.low.effect')
    //     }
    // }
    // _G.__use_small_res = _G.__use_low_effect
    // _G.__use_res_scale = _G.__use_small_res && 0.625 || 1
    _G.__level_effect = "NORMAL" // LOW, NORMAL 2024年新加关卡内效果等级，__use_low_effect目前不再使用
    // 默认NORMAL，设备缓存里记录了会改成LOW
    let value = cc.UserDefault.getInstance().getStringForKey(LOCAL_SETTING_KEY)
    try {
        value = JSON.parse(value)
        if (value["GameEffectLevelLow"] && value["GameEffectLevelLow"] == 1) {
            _G.__level_effect = "LOW"
        }
    } catch (error) {
        
    }
    
    _G.__use_small_res = false
    _G.__use_low_effect = false
    _G.__use_res_scale = 1
}


var Processor = {}
Processor.start = function (finishCallback) {
    decideUseLowEffect()
    finishCallback && finishCallback()
}

module.exports = Processor
